/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettingsCriterionEnumEnum {
    STATUS = 'STATUS'
}
